@let user = user$ | async;

@if (!user) {
  <header class="ap ap-shell">
    <nav class="ap-nav" [attr.aria-label]="'header.primaryNav' | translate">
      <div class="ap-nav__inner">
        <a routerLink="/" class="ap-brand" [attr.aria-label]="'header.brandHome' | translate">
          <app-brand-logo />
        </a>

        <div class="ap-nav__links">
          <!-- Discover hidden for now (route still live); un-comment to restore -->
          <!-- <a routerLink="/discover" routerLinkActive="is-active" class="ap-nav__link">{{ 'header.discover' | translate }}</a> -->
          <a routerLink="/partners" routerLinkActive="is-active" class="ap-nav__link">{{ 'header.forClubs' | translate }}</a>
        </div>

        <div class="ap-nav__right">
          <button
            type="button"
            (click)="toggleTheme()"
            class="ap-nav__icon ap-focus"
            [attr.aria-label]="
              ((themeService.theme$ | async) === 'dark'
                ? 'header.switchToLight'
                : 'header.switchToDark'
              ) | translate
            "
            [title]="'header.toggleTheme' | translate"
          >
            <i
              class="pi"
              [ngClass]="
                (themeService.theme$ | async) === 'dark' ? 'pi-sun' : 'pi-moon'
              "
            ></i>
          </button>

          <app-language-switcher />
          <a routerLink="/auth/login" class="ap-nav__link">{{ 'header.logIn' | translate }}</a>
          <a routerLink="/auth/signup" class="ap-btn ap-btn--filled ap-btn--sm">{{ 'header.signUp' | translate }}</a>
        </div>
      </div>
    </nav>
  </header>
} @else {
  <header
    class="ap ap-shell"
    [class.lg:ml-64]="sidebarOpen"
    [class.lg:ml-16]="!sidebarOpen"
  >
    <nav class="ap-nav" [attr.aria-label]="'header.primaryNav' | translate">
      <div class="ap-nav__inner ap-nav__inner--app">
        <div class="ap-nav__group">
          <button
            (click)="toggleSidebar()"
            class="ap-nav__icon ap-focus"
            [attr.aria-label]="'header.toggleNav' | translate"
          >
            <svg
              class="h-5 w-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 6h16M4 12h16M4 18h16"
              ></path>
            </svg>
          </button>
          <a routerLink="/" class="ap-brand" [attr.aria-label]="'header.brandHome' | translate">
            <app-brand-logo />
          </a>
        </div>

        <div class="ap-nav__right">
          <app-language-switcher />
          <app-notification-bell></app-notification-bell>

          <button
            type="button"
            (click)="toggleTheme()"
            class="ap-nav__icon ap-focus"
            [attr.aria-label]="
              ((themeService.theme$ | async) === 'dark'
                ? 'header.switchToLight'
                : 'header.switchToDark'
              ) | translate
            "
            [title]="'header.toggleTheme' | translate"
          >
            <i
              class="pi"
              [ngClass]="
                (themeService.theme$ | async) === 'dark' ? 'pi-sun' : 'pi-moon'
              "
            ></i>
          </button>

        </div>
      </div>
    </nav>
  </header>
}
